<template>
  <div id="ProductsListPage">
    <NavBar/>
    <v-main v-if="isContentLoaded" class="third-bg">
      <div class="container-fluid third-bg ">
        <div class="row">
          <div class="col-12 text-center pt-10 ">
            <h1>
              <span class="font-19 border-bottom-gold px-5">محصولات {{ categoryDetail.Name }}</span>
            </h1>
          </div>
          <div v-if="showCategorySection" class="col-12">
            <div class="row">
              <div class="col-md-5 col-lg-3">
                <v-img
                    :src="$replaceHttps(categoryDetail.FileUrl)">
                </v-img>
              </div>
              <div class="col-md-7 col-lg-9">
                <div class="font-weight-bold"> دسته بندی {{ categoryDetail.Name }}</div>
                <div class="mt-3" v-html="categoryDetail.Description">
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 third-bg">
            <div v-if="digitalProducts.length >0 " class="row">
              <div v-for="(item,i) in digitalProducts" :key="i" class="col-md-6 col-lg-4 ">
                <ProductsCard :item="item"/>
              </div>
            </div>
            <div v-else class="row">
              <v-alert class="col-12 text-center mt-3" color="primary" outlined>محصولی موجود نیست.</v-alert>
            </div>
            <!--            <v-tabs
                            v-model="tabs">
                          <v-tab
                              href="#0">
                            فیزیکی
                          </v-tab>
                          <v-tab
                              href="#1">
                            دیجیتالی
                          </v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tabs">
                          <v-tab-item value="0">
                            <v-card flat>
                              <v-card-text class="p-0">
                                <div class="container-fluid container-md">
                                  <div v-if="physicalProducts.length >0 " class="row">
                                    <div v-for="(item,i) in physicalProducts" :key="i" class="col-md-6 col-lg-4 ">
                                      <ProductsCard :item="item"/>
                                    </div>
                                  </div>
                                  <div v-else class="row">
                                    <v-alert class="col-12 text-center mt-3" outlined color="primary">محصولی موجود نیست.</v-alert>
                                  </div>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-tab-item>
                          <v-tab-item value="1">
                            <v-card flat>
                              <v-card-text class="p-0">
                                <div class="container-fluid container-md ">
                                  <div class="row">
                                    <div v-if="digitalProducts.length >0 " class="row">
                                      <div v-for="(item,i) in digitalProducts" :key="i" class="col-md-6 col-lg-4 ">
                                        <ProductsCard :item="item"/>
                                      </div>
                                    </div>
                                    <div v-else class="row">
                                      <v-alert class="col-12 text-center mt-3" outlined color="primary">محصولی موجود نیست.</v-alert>
                                    </div>
                                  </div>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-tab-item>
                        </v-tabs-items>-->
          </div>
        </div>
      </div>
    </v-main>
    <FooterComponent/>
    <v-overlay
        v-model="showLoaderDialog"
        persistent
        width="500">
      <v-progress-circular
          color="white"
          indeterminate
          size="50"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import ProductsCard from "@/Academy/components/ProductsCard";
import NavBar from "@/Academy/components/NavBar";
import FooterComponent from "@/Academy/components/Footer";

export default {
  name: "ProductsList",
  metaInfo () {
    return {
      title: window.projectName + this.$route.name,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  components: {FooterComponent, NavBar, ProductsCard},
  data: () => ({
    tabs: null,
    typeSort: null,
    typeProduct: null,
    pageIndex: null,
    pageSize: null,
    books: [
      {
        imgSrc: '1.png',
        title: 'صد و یک راز بنگاه داری',
        price: '80000 ',
        discount: '10'
      },
      {
        imgSrc: '2.png',
        title: 'صد و یک راز بنگاه داری',
        price: '120000 ',
        discount: '0'
      },
      {
        imgSrc: '3.png',
        title: 'صد و یک راز بنگاه داری',
        price: '0',
        discount: '0'
      },

    ],
    dvd: [
      {
        imgSrc: '1.png',
        title: 'صد و یک راز بنگاه داری',
        price: '80000 ',
        discount: '5'
      },
      {
        imgSrc: '2.png',
        title: 'صد و یک راز بنگاه داری',
        price: '120000 ',
        discount: '2'
      },
      {
        imgSrc: '3.png',
        title: 'صد و یک راز بنگاه داری',
        price: '0',
        discount: '0'
      },

    ],
    pageTitle: '',
    showCategorySection: true,
    showLoaderDialog: false,
    isContentLoaded: false,
    categoryDetail: {},
    physicalProducts: [],
    digitalProducts: [],
  }),
  mounted () {
    this.getCategory()
    let type = this.$route.query.type
    if (type !== undefined) {
      this.tabs = this.$route.query.type
      if (type === '1') {
        this.pageTitle = 'دیجیتالی'
      } else if (type === '0') {
        this.pageTitle = 'فیزیکی'
      }
    }
    let cateId = this.$route.query.categoryID
    if (cateId !== undefined) {
      this.pageTitle = " 'نام دسته بندی'"
    } else {
      this.showCategorySection = false
    }
  },
  methods: {
    getCategory () {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/Client/ProductCategories", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.categoryDetail = JSON.parse(result).filter(x => x.ProductCategoryId === this.$route.query.categoryID)[0]
            this.showLoaderDialog = false
            this.getProducts()
          })
          .catch(error => console.log('error', error));
    },
    getProducts () {
      this.showLoaderDialog = true
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      var url = "/Client/Products?categoryId="
      url += this.$route.query.categoryID
      if (this.typeSort !== null) {
        url += "&typeSort=" + this.typeSort;
      }
      if (this.typeProduct !== null) {
        url += "&typeProduct=" + this.typeProduct;
      }

      if (this.pageIndex !== null) {
        url += "&pageIndex=" + this.pageIndex;
      }
      if (this.pageSize !== null) {
        url += "&pageSize=" + this.pageSize;
      }

      fetch(this.$baseUrl + url, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.showLoaderDialog = false
            this.physicalProducts = json.list;
            this.digitalProducts = json.list;
            this.isContentLoaded = true
          })
          .catch(error => console.log('error', error));
    },
  }
}
</script>

<style scoped>

</style>
